// $FlowFixMe
import { format as formatDateFns } from 'date-fns';
import esLocale from 'date-fns/locale/es';

export const convertDate = (date: Date, format = 'yyyy-MM-dd') => {
  const d = (date.getDate() < 10 ? '0' : '') + date.getDate();
  const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
  const year = date.getFullYear();

  let newFormat = '';

  if (format === 'yyyy-MM-dd') newFormat = `${year}-${month}-${d}`;
  if (format === 'MM/01/yyyy') newFormat = `${month}/01/${year}`;
  return newFormat;
};

export const formatDate = (
  date: Date,
  dateFormat = 'dd/MM/yyyy',
  options = { locale: esLocale },
) => {
  return formatDateFns(date, dateFormat, options);
};
